import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import SaveIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
// material-ui
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
// styles
import styles from "./styles";

class FormInstrumentSection extends PureComponent {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,
    instrumentFamilies: PropTypes.array,

    close: PropTypes.func,
    open: PropTypes.bool,

    instrumentSection: PropTypes.object,
    selectedFamily: PropTypes.object,

    createInstrumentSection: PropTypes.func,
    updateInstrumentSection: PropTypes.func,
    deleteInstrumentSection: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      name: "",
      familyID: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.init(nextProps);
    }
  }

  handleChange = (name) => (event) => {
    const { target } = event;
    const { value } = target;

    this.setState({
      [name]: value,
    });
  };

  init(props) {
    const { selectedFamily, instrumentSection } = props;
    const familyID = instrumentSection ? instrumentSection.familyID : "";
    this.setState({
      loading: false,
      name: instrumentSection ? instrumentSection.name : "",
      familyID: selectedFamily ? selectedFamily.id : familyID,
    });
  }

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: "Are you sure ?",
        subtitle:
          "If you delete this instrument Section, you won't be able to recover it.",
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: "Cancel",
          level: "default",
          callback: () => console.log("Callback"),
        },
        confirm: {
          label: "I am sure",
          level: "error",
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const {
      deleteInstrumentSection,
      close,
      refresh,
      instrumentSection,
    } = this.props;

    const { NotificationCenter } = this.context;
    close();
    const resp = await deleteInstrumentSection(instrumentSection.id);
    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: "Instrument Section has been deleted.",
        success: true,
        timestamp: new Date().getTime(),
      });
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async save() {
    const {
      updateInstrumentSection,
      createInstrumentSection,
      instrumentSection,
      refresh,
      close,
    } = this.props;

    const { name, familyID } = this.state;

    const { NotificationCenter } = this.context;

    let resp;
    this.setState({ loading: true });
    if (instrumentSection) {
      resp = await updateInstrumentSection(instrumentSection.id, {
        name,
        familyID,
      });
    } else {
      resp = await createInstrumentSection({
        name,
        familyID,
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: instrumentSection
          ? "Instrument Section has been updated."
          : "InstrumentSection has been created.",
        success: true,
        timestamp: new Date().getTime(),
      });

      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  render() {
    const {
      classes,
      fullScreen,
      open,
      instrumentSection,
      close,
      instrumentFamilies,
    } = this.props;

    const { name, familyID, loading } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        aria-labelledby="responsive-dialog-title"
      >
        {loading ? (
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">Loading</DialogTitle>
            <CircularProgress color="secondary" />
          </div>
        ) : (
          <div>
            <DialogTitle id="responsive-dialog-title">
              {instrumentSection
                ? `${instrumentSection.name}`
                : "Let's Create a New Instrument Section"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {instrumentSection
                  ? "To update the instrument Section, fill the form below :"
                  : "To create a new instrument Section, fill the form below :"}
              </DialogContentText>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    label="Name"
                    className={classes.textField}
                    value={name}
                    onChange={this.handleChange("name")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth>
                    <InputLabel htmlFor="Family-simple">Family</InputLabel>
                    <Select
                      inputProps={{
                        name: "Family",
                        id: "Family-simple",
                      }}
                      value={familyID}
                      onChange={this.handleChange("familyID")}
                    >
                      {instrumentFamilies.map((i) => (
                        <MenuItem key={`instrumentFamily_${i.id}`} value={i.id}>
                          {i.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {instrumentSection && (
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} />
                  &nbsp;Delete
                </Button>
              )}
              <Button onClick={close}>
                <CloseIcon className={classes.leftIcon} />
                &nbsp;Close
              </Button>
              <Button color="primary" autoFocus onClick={this.save.bind(this)}>
                <SaveIcon className={classes.leftIcon} />
                {instrumentSection ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormInstrumentSection));
